import React, { useState, useContext } from 'react';
import { Mail, Lock, LogIn, UserPlus, Globe } from 'lucide-react';

import {
    signUpWithEmail,
    signInWithEmail,
    signInWithGoogle,
    signInAsGuest
} from '../services/AuthService';

// FirebaseContextをインポート (App.jsからpropsで渡す代わりにContextを使用)
import { FirebaseContext } from '../App'; // App.jsからFirebaseContextをインポート

const SignInScreen = () => {
    // Contextから必要なものを取得 (今回はサインイン処理に直接は不要だが、将来的な拡張性のため)
    // const { db, auth, userId, handleLogout } = useContext(FirebaseContext);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    const handleEmailSignUp = async (e) => {
        e.preventDefault();
        setMessage('');
        if (!email || !password) {
            setMessage('メールアドレスとパスワードを入力してください。');
            setMessageType('error');
            return;
        }
        try {
            await signUpWithEmail(email, password);
            setMessage('アカウントが作成されました！');
            setMessageType('success');
        } catch (error) {
            console.error("サインアップエラー:", error);
            setMessage('サインアップに失敗しました: ' + error.message);
            setMessageType('error');
        }
    };

    const handleEmailSignIn = async (e) => {
        e.preventDefault();
        setMessage('');
        if (!email || !password) {
            setMessage('メールアドレスとパスワードを入力してください。');
            setMessageType('error');
            return;
        }
        try {
            await signInWithEmail(email, password);
            setMessage('ログインしました！');
            setMessageType('success');
        } catch (error) {
            console.error("ログインエラー:", error);
            setMessage('ログインに失敗しました: ' + error.message);
            setMessageType('error');
        }
    };

    const handleGoogleSignIn = async () => {
        setMessage('');
        try {
            await signInWithGoogle();
            setMessage('Googleでログインしました！');
            setMessageType('success');
        } catch (error) {
            console.error("Googleログインエラー:", error);
            // ユーザーがポップアップを閉じた場合のエラーを区別
            if (error.code === 'auth/popup-closed-by-user') {
                setMessage('Google認証をキャンセルしました。');
                setMessageType('info');
            } else {
                setMessage('Googleログインに失敗しました: ' + error.message);
                setMessageType('error');
            }
        }
    };

    const handleAnonymousSignIn = async () => {
        setMessage('');
        try {
            await signInAsGuest();
            setMessage('ゲストとして続行します。');
            setMessageType('success');
        } catch (error) {
            console.error("匿名ログインエラー:", error);
            setMessage('ゲストログインに失敗しました: ' + error.message);
            setMessageType('error');
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
            <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
                <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">みんなの会計 MoneyBoardへようこそ</h2>
                {message && (
                    <div className={`p-4 rounded-md mb-4 text-center ${messageType === 'success' ? 'bg-green-100 text-green-700' : messageType === 'info' ? 'bg-blue-100 text-blue-700' : 'bg-red-100 text-red-700'}`}>
                        {message}
                    </div>
                )}
                <form className="space-y-4">
                    <div>
                        <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">メールアドレス</label>
                        <div className="relative">
                            <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="shadow appearance-none border rounded-lg w-full py-3 px-4 pl-10 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-400"
                                placeholder="メールアドレス"
                                autoComplete="username"
                                required
                            />
                        </div>
                    </div>
                    <div>
                        <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">パスワード</label>
                        <div className="relative">
                            <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="shadow appearance-none border rounded-lg w-full py-3 px-4 pl-10 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-400"
                                placeholder="パスワード"
                                autoComplete="current-password"
                                required
                            />
                        </div>
                    </div>
                    <div className="flex flex-col gap-3">
                        <button
                            type="submit"
                            onClick={handleEmailSignIn}
                            className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-200 ease-in-out shadow-md flex items-center justify-center gap-2"
                        >
                            <LogIn size={20} />
                            ログイン
                        </button>
                        <button
                            type="button"
                            onClick={handleEmailSignUp}
                            className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-200 ease-in-out shadow-md flex items-center justify-center gap-2"
                        >
                            <UserPlus size={20} />
                            新規登録
                        </button>
                    </div>
                </form>
                <div className="my-6 text-center text-gray-600">または</div>
                <div className="flex flex-col gap-3">
                    <button
                        type="button"
                        onClick={handleGoogleSignIn}
                        className="w-full bg-red-500 hover:bg-red-600 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-200 ease-in-out shadow-md flex items-center justify-center gap-2"
                    >
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12.24 10.29v2.24h6.08c-.28 1.14-1.12 2.75-3.08 3.99l.06.33 2.07 1.6c1.23-1.11 2.37-2.67 3.0-4.62l.07-.38h-.07c.56-1.57.88-3.23.88-4.92s-.32-3.35-.88-4.92l.07-.38-2.07-1.6-.06.33c-1.96-1.24-2.8-2.85-3.08-3.99H12.24v2.24h-1.5v2.24h1.5v2.24zm-1.5 0v-2.24h-1.5v-2.24h1.5v-2.24h-1.5v-2.24H12.24c-1.84 0-3.32.17-4.44.5l-.26.11-.06-.33c-.28-1.14-1.12-2.75-3.08-3.99l-.06-.33-2.07 1.6-.06.33c-1.23 1.11-2.37 2.67-3.0 4.62l-.07.38h-.07c-.56 1.57-.88 3.23-.88 4.92s.32 3.35.88 4.92l.07.38 2.07 1.6.06-.33c1.96-1.24 2.8-2.85 3.08-3.99H12.24v-2.24h1.5v-2.24H12.24z" />
                        </svg>
                        Googleでログイン
                    </button>
                    <button
                        type="button"
                        onClick={handleAnonymousSignIn}
                        className="w-full bg-gray-600 hover:bg-gray-700 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-200 ease-in-out shadow-md flex items-center justify-center gap-2"
                    >
                        <Globe size={20} />
                        ゲストとして続行
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SignInScreen;
